export default function Footer() {
  return (
    <footer className="border-t border-border/40 py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <p className="font-heading text-2xl tracking-widest-xl mb-4">
              LYKKE <span className="font-light opacity-60">NOMAD</span>
            </p>
            <p className="text-foreground/70 font-body leading-relaxed max-w-sm" style={{ fontSize: "23px" }}>Vi designer og bygger badstuer. Nordisk arkitektur tilpasset naturen.

            </p>
          </div>

          <div>
            <p className="text-sm tracking-widest-xl font-body uppercase text-primary mb-4">
              Sider
            </p>
            <div className="space-y-2">
              {[
              { label: "Hjem", href: "/" },
              { label: "Om oss", href: "/om-oss" },
              { label: "Badstuer", href: "/sauna-ly" },
              { label: "Konfigurator", href: "/konfigurator" },
              { label: "Prosess", href: "/process" }].
              map((link) =>
              <a
                key={link.label}
                href={link.href} className="text-foreground/70 font-body block hover:text-foreground transition-colors" style={{ fontSize: "23px" }}>
                
                
                  {link.label}
                </a>
              )}
            </div>
          </div>

          <div>
            <p className="text-primary mb-4 text-base font-body uppercase tracking-widest-xl">KONTAKT

            </p>
            <div className="space-y-2 font-body text-foreground/70" style={{ fontSize: "23px" }}>
              <p>info@lykke.info</p>
              <p className="font-bold">+47 96838088</p>
              <p>Selma Ellefsens vei 6<br />0581 Oslo, Norge</p>

            </div>
            <div className="flex gap-5 mt-6">
              {/* Instagram */}
              <a href="https://www.instagram.com/lykke.nomad/" target="_blank" rel="noopener noreferrer"
                className="text-foreground/60 hover:text-foreground transition-colors" title="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none"/>
                </svg>
              </a>
              {/* Facebook */}
              <a href="https://www.facebook.com/lykke.nomad/" target="_blank" rel="noopener noreferrer"
                className="text-foreground/60 hover:text-foreground transition-colors" title="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              {/* Finn.no */}
              <a href="https://www.finn.no/butikk/935094984" target="_blank" rel="noopener noreferrer"
                className="opacity-70 hover:opacity-100 transition-opacity" title="Finn.no">
                <img src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/67b4f4b97_finn_ikonka_bez_tla_przycieta.png" alt="Finn.no" style={{ height: 22, width: 'auto' }} width="80" height="22" loading="lazy" decoding="async" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border/30 pt-8">
          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-8 mb-6 font-body text-xs text-foreground/60 uppercase tracking-widest">
            <a href="/privacy-policy" className="hover:text-foreground/60 transition-colors">Privatlivspolicy</a>
            <a href="/cookie-policy" className="hover:text-foreground/60 transition-colors">Informasjonskapsler</a>
            <a href="/terms-of-service" className="hover:text-foreground/60 transition-colors">Vilkår for bruk</a>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="font-body text-xs text-foreground/70 space-y-1">
            <p className="text-base">© {new Date().getFullYear()} LYKKE NOMAD. Alle rettigheter reservert.</p>
            <p>Lykke Home AS</p>
            <p>Org. nr. 928 990 958</p>
          </div>
            <p className="font-body text-xs text-foreground/60">
              Nordisk arkitektur, tilpasset naturen.
            </p>
          </div>
        </div>
      </div>
    </footer>);

}